import { render, staticRenderFns } from "./MenuDown.vue?vue&type=template&id=5c15739c&"
import script from "./MenuDown.vue?vue&type=script&lang=js&"
export * from "./MenuDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports